var map = {
	"./icon-aggregate.svg": "d933",
	"./icon-calc.svg": "3d36",
	"./icon-check.svg": "e9af",
	"./icon-comment.svg": "8441",
	"./icon-hint.svg": "8dcd",
	"./icon-text.svg": "dc1a",
	"./icon-type.svg": "4881"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9fdc";